import actions from './actions-customer.js'
import mutations from './mutations-customer.js'
import getters from './getters-customer.js'
import state from './state-customer.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}